import { render, staticRenderFns } from "./NumberList.vue?vue&type=template&id=7c644c57&scoped=true"
import script from "./NumberList.vue?vue&type=script&lang=js"
export * from "./NumberList.vue?vue&type=script&lang=js"
import style0 from "./NumberList.vue?vue&type=style&index=0&id=7c644c57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c644c57",
  null
  
)

export default component.exports